import { useQuery } from '@tanstack/react-query'
import { client } from './';

const getData = async () => {
  const api = client.initIndex('assets')
  const data = await api.search('')
  // @ts-ignore
  return data.hits?.map((h) => h.name)
}

export default function useGetPopularQuerySuggestion() {
  return useQuery({
    queryKey: ['useGetPopularQuerySuggestion'],
    queryFn: () => getData(),
    staleTime: 0,
    cacheTime: 0,
  })
}
